import { createFeatureSelector, createSelector } from '@ngrx/store';

import { IAuthFeatureStateModel } from '@features/auth/models';

export const authFeatureName = 'authFeature';

export const getAuthState = createFeatureSelector<IAuthFeatureStateModel>(authFeatureName);

export const getUserState = createSelector(getAuthState, (state) => state.user);
